import { ReactNode } from "react";

interface InstructionsDetailsProps {
  title: string;
  children: ReactNode;
}

const InstructionsDetails = ({ title, children }: InstructionsDetailsProps) => {
  return (
    <details className="info-details">
      <summary>
        <span className="info-details-icon">&#9654;</span>
        {title}
      </summary>
      <div className="info-details-content">
        {children}
      </div>
    </details>
  );
};

export default InstructionsDetails;
